module.exports = __webpack_public_path__ + "static/media/ios-egg.61371e93.svg";